/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'
import Router from '@titanio/router'
import postblog from './utils/postblog'
import categories from './utils/categories'

const loader = () => {
  const queue = new IdleQueue()
  const router = new Router()

  router.get(['/blog/', '/blog/:slug/'], (req) => {
    if (categories.isInvalid(req)) return

    import(
      /* webpackChunkName: "home-page" */
      '@pages/home'
    ).then((page) => {
      page.default.mount()
    })
  })

  router.get('/blog/autor/:slug/', () => {
    import(
      /* webpackChunkName: "author-page" */
      '@pages/author'
    ).then((page) => {
      page.default.mount()
    })
  })

  router.get(['/:slug/', '/:slug/:subslug/', '/blog/:slug/'], (req) => {
    if (postblog.isInvalid(req)) return

    import(
      /* webpackChunkName: "postblog-page" */
      '@pages/postblog'
    ).then((page) => {
      page.default.mount()
    })
  })

  queue.pushTask(() => router.init())
}

export default { loader }
